// @flow
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import ListItem from '@material-ui/core/ListItem';

const useStyles = makeStyles(theme => ({
  item: {
    padding: '12px 28px',
    '&:hover': {
      backgroundColor: theme.palette.type === 'light' ? theme.palette.ava.navy5 : theme.palette.ava.grey5,
    },
  },
  active: {
    backgroundColor: theme.palette.ava.navy,
    color: theme.palette.ava.white,
    '&:hover': {
      cursor: 'default',
      backgroundColor: theme.palette.ava.navy,
    },
  },
  text: {
    marginLeft: 16,
    fontSize: 18,
  },
  disabled: { opacity: '1 !important' },
}));

interface Props {
  active?: boolean;
  className?: string;
  disableOnClick?: boolean;
  icon: Object;
  text: string;
  product?: string;
  onClick?: Function;
  history: Object;
  sidebarOpen: boolean;
}

const SidebarItem = ({ active, className, disableOnClick, icon, text, onClick, sidebarOpen }: Props) => {
  const classes = useStyles();

  const [textVisible, setTextVisible] = useState(true);

  useEffect(() => {
    if (sidebarOpen) {
      setTimeout(() => setTextVisible(true), 200);
    } else {
      setTextVisible(false);
    }
  }, [sidebarOpen]);

  return (
    <ListItem
      className={classnames(classes.item, className, {
        [classes.active]: active,
      })}
      classes={{ disabled: classes.disabled }}
      role="button"
      button
      disabled={active}
      onClick={disableOnClick ? null : onClick}
    >
      {icon}
      {textVisible && <span className={classes.text}>{text}</span>}
    </ListItem>
  );
};

const mapStateToProps = ({ scribeSession: { sidebar } }) => ({
  sidebarOpen: sidebar,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SidebarItem));
